import { parsePhoneNumberFromString } from 'libphonenumber-js';

/**
 * Splits what an admin typed into the Location Users search box into the one
 * param auth-service should get: `phone` for a full phone number, `search` for
 * anything else. The endpoint ANDs the two, so sending both would narrow a
 * phone lookup to names and emails that contain the digits.
 *
 * `extract: false` keeps the whole input in play. The library's default pulls
 * a number out of surrounding text, which would turn `bob3055550123@gmail.com`
 * or `Alice 3055550123` into a phone lookup and miss the row the admin meant.
 *
 * `isPossible` (length), not `isValid` (assigned ranges): auth-service
 * normalises `phone` to E.164 without validating it and compares exactly, so
 * a well-formed but unassigned number still has to go as `phone` to find the
 * account stored with it. A partial number is not possible and stays `search`.
 *
 * @param {string} input - The search box value
 * @returns {{ phone: string } | { search: string } | {}} Params to send
 */
export const toUserSearchParams = (input) => {
  const trimmed = (input ?? '').trim();
  if (!trimmed) return {};

  const parsed = parsePhoneNumberFromString(trimmed, { defaultCountry: 'US', extract: false });
  if (parsed?.isPossible()) return { phone: parsed.number };

  return { search: trimmed };
};
